@use '../../assets/styles/utilities.scss';

:host {
  display: block;
}
.top-fixed-bg {
  background-color: #151921;
}
.sec-text-color {
  color: #f7f7f7;
}
